<template lang="pug">
  .TheFooterContacts.footer-contacts
    ul.footer-contacts__list
      li.footer-contacts__list-item
        a.link-1.footer-contacts__list-item-link(
          :href="`mailto:${CONTACTS.email}`"
        )
          SolidEnvelopeIcon.svg-icon.footer-contacts__list-item-link-icon
          span.footer-contacts__list-item-link-text {{ CONTACTS.email }}
      li.footer-contacts__list-item
        a.link-1.footer-contacts__list-item-link(
          :href="`tel:${CONTACTS.phone}`"
        )
          SolidPhoneIcon.svg-icon.footer-contacts__list-item-link-icon
          span.footer-contacts__list-item-link-text {{ CONTACTS.phone }}
    ul.footer-contacts__list
      li.footer-contacts__list-item.is--last-list-item
        a.link-1.footer-contacts__list-item-link(
          :href="`${CONTACTS.mapLink}`",
          target="_blank"
        )
          SolidMapMarkerAltIcon.svg-icon.footer-contacts__list-item-link-icon
          span
            span.footer-contacts__list-item-link-text {{ CONTACTS.streetAddress }},
            span.footer-contacts__list-item-link-text  {{ CONTACTS.addressLocality }},
            span.footer-contacts__list-item-link-text  {{ CONTACTS.addressRegion }}
            span.footer-contacts__list-item-link-text  {{ CONTACTS.postalCode }}
</template>

<script>
import { CONTACTS } from 'Config/constans';
import SolidEnvelopeIcon from 'images/svg-icons/solid-envelope.svg';
import SolidPhoneIcon from 'images/svg-icons/solid-phone.svg';
import SolidMapMarkerAltIcon from 'images/svg-icons/solid-map-marker-alt.svg';

export default {
  name: 'TheFooterContacts',
  components: {
    SolidEnvelopeIcon,
    SolidPhoneIcon,
    SolidMapMarkerAltIcon,
  },
  staticData: {
    CONTACTS,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-contacts
  &__list
    list-style-type: none
    padding-left: 0
    margin-bottom: 0
  &__list-item
    width: auto
    margin-bottom: 20px
    &.is--last-list-item
      margin-bottom: 0
  &__list-item-link
    +font(400)
    line-height: 22px
    display: flex
    align-items: center
    &:hover
      border-bottom: solid 1px transparent
      .footer-contacts__list-item-link-text
        +mt(.3s)
        border-bottom: solid 1px transparent
  &__list-item-link-icon
    width: auto
    height: 16px
    flex-shrink: 0
    padding: 1px
    fill: $tones-gray-50
    position: relative
    margin-right: 8px
    +mt(.3s)
  &__list-item-link-text
    +mt(.3s)
    border-bottom: solid 1px $alabaster

</style>
